import { useState, useEffect } from "react";
import useProfileData from "./useProfileData";
import axios from "axios";
import {  useLocation } from "react-router-dom";

const baseURL = `${process.env.REACT_APP_API_URL}`

export default function useReviews() {
    const [reviews, setReviews] = useState([]);
    const { profile } = useProfileData();
    const [newReviews, setNewReviews] = useState('');
    const [newRating, setNewRating] = useState()
    const [success, setSuccess] = useState('');

    const location = useLocation()

    const userId = profile?.user_id;

    const userType = location.pathname.includes("house_manager") ? "house_manager" : "employer";

    useEffect(() => {
            if (profile) {
            // const userId = profile.user_id;
    
            const fetchReviews = async () => {
                try {
                const response = await axios.get(`${baseURL}/profiles/reviews/${userId}/`);
                setReviews(response.data)
                console.log(`Reviews API URL: ${baseURL}/profiles/reviews/${userId}/`)
                console.log(`Fetched reviews for user ID ${userId}:`, response.data)
                } catch (error) {
                console.error('Error fetching reviews:', error);
                }
            };
            fetchReviews();
        }
 
    }, [ profile]);

    const handleReviewsSubmit = () => {
        if (!newReviews.trim()) {
            console.error('Review cannot be empty')
            return;
        }

        const token = localStorage.getItem('accessToken')
        if (!token) {
            console.error('Please log in to submit a review')
            return;
        }

        if (newRating < 1 || newRating > 5) {
            console.error('Rating must be between 1 and 5')
            return;
        }

        if (!userType || !userId) {
            console.error('User type or ID not found')
            return;
        }
        axios
            .post(
            `${baseURL}/profiles/reviews_submit/${userType}/${userId}/`,
                {
                comment: newReviews,
                rating: newRating,
                },
                {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                }
            )
            .then((response) => {
            console.log('Submitted reviews:', response.data)
            setSuccess('Review submitted successfully')
            setReviews([...reviews, response.data])
            setNewReviews('')
            setNewRating(0)
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                console.error(error.response.data.non_field_errors || "An error occurred")
                } else {
                console.error("An error occurred")
                }
            });
    };

    return { reviews, handleReviewsSubmit, newReviews, setNewReviews, newRating, setNewRating, success  };

}